import { render, staticRenderFns } from "./MyWordTree.vue?vue&type=template&id=d57307f0"
import script from "./MyWordTree.vue?vue&type=script&lang=js"
export * from "./MyWordTree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports